"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/testing/underwriting-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Ftesting%2Funderwriting-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTestUserResponse = exports.GetTestUserResponse = exports.GetTestUserRequest = exports.UpdateTestUserRequest = exports.ResetReapplyCooldownResponse = exports.ResetReapplyCooldownRequest = exports.WithdrawApplicationResponse = exports.WithdrawApplicationRequest = exports.GetCreditScoreReasonsResponseReasonsEntry = exports.GetCreditScoreReasonsResponse = exports.GetCreditScoreReasonsRequest = exports.GetCreditAgencyDataResponse = exports.GetCreditAgencyDataRequest = exports.SetCreditAgencyDataResponse = exports.SetCreditAgencyDataRequest = exports.SetApplicationProductsResponse = exports.SetApplicationProductsRequest = exports.SetApplicationStatusResponse = exports.SetApplicationStatusRequest = exports.GetApplicationResponse = exports.GetApplicationRequest = exports.MockCreditAgencyData = exports.TestUserData = void 0;
const application_1 = require("../application");
const circuit_breakers_1 = require("../circuit-breakers");
const fraud_alert_1 = require("../fraud-alert");
const product_1 = require("../product");
const reason_codes_1 = require("../reason-codes");
const protobufPackage = 'com.step.underwriting.testing.proto';
function createBaseTestUserData() {
    return { creditAgencyData: undefined, circuitBreakers: undefined };
}
exports.TestUserData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditAgencyData)) {
            message.creditAgencyData = exports.MockCreditAgencyData.fromJSON(object.creditAgencyData);
        }
        if (isSet(object.circuitBreakers)) {
            message.circuitBreakers = circuit_breakers_1.CircuitBreakers.fromJSON(object.circuitBreakers);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditAgencyData !== undefined) {
            obj.creditAgencyData = exports.MockCreditAgencyData.toJSON(message.creditAgencyData);
        }
        if (message.circuitBreakers !== undefined) {
            obj.circuitBreakers = circuit_breakers_1.CircuitBreakers.toJSON(message.circuitBreakers);
        }
        return obj;
    },
    create(base) {
        return exports.TestUserData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestUserData();
        message.creditAgencyData =
            (object.creditAgencyData !== undefined && object.creditAgencyData !== null)
                ? exports.MockCreditAgencyData.fromPartial(object.creditAgencyData)
                : undefined;
        message.circuitBreakers =
            (object.circuitBreakers !== undefined && object.circuitBreakers !== null)
                ? circuit_breakers_1.CircuitBreakers.fromPartial(object.circuitBreakers)
                : undefined;
        return message;
    },
};
function createBaseMockCreditAgencyData() {
    return {
        creditScore: 0,
        hasFreeze: undefined,
        reasonCodes: undefined,
        isDeceased: undefined,
        mlaMatch: undefined,
        fraudAlerts: undefined,
    };
}
exports.MockCreditAgencyData = {
    fromJSON(object) {
        const message = {
            creditScore: isSet(object.creditScore) ? globalThis.Number(object.creditScore) : 0,
        };
        if (isSet(object.hasFreeze)) {
            message.hasFreeze = globalThis.Boolean(object.hasFreeze);
        }
        if (isSet(object.reasonCodes)) {
            message.reasonCodes = reason_codes_1.ReasonCodes.fromJSON(object.reasonCodes);
        }
        if (isSet(object.isDeceased)) {
            message.isDeceased = globalThis.Boolean(object.isDeceased);
        }
        if (isSet(object.mlaMatch)) {
            message.mlaMatch = globalThis.Boolean(object.mlaMatch);
        }
        if (isSet(object.fraudAlerts)) {
            message.fraudAlerts = fraud_alert_1.FraudAlertTypes.fromJSON(object.fraudAlerts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditScore !== 0) {
            obj.creditScore = Math.round(message.creditScore);
        }
        if (message.hasFreeze !== undefined) {
            obj.hasFreeze = message.hasFreeze;
        }
        if (message.reasonCodes !== undefined) {
            obj.reasonCodes = reason_codes_1.ReasonCodes.toJSON(message.reasonCodes);
        }
        if (message.isDeceased !== undefined) {
            obj.isDeceased = message.isDeceased;
        }
        if (message.mlaMatch !== undefined) {
            obj.mlaMatch = message.mlaMatch;
        }
        if (message.fraudAlerts !== undefined) {
            obj.fraudAlerts = fraud_alert_1.FraudAlertTypes.toJSON(message.fraudAlerts);
        }
        return obj;
    },
    create(base) {
        return exports.MockCreditAgencyData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMockCreditAgencyData();
        message.creditScore = object.creditScore ?? 0;
        message.hasFreeze = object.hasFreeze ?? undefined;
        message.reasonCodes = (object.reasonCodes !== undefined && object.reasonCodes !== null)
            ? reason_codes_1.ReasonCodes.fromPartial(object.reasonCodes)
            : undefined;
        message.isDeceased = object.isDeceased ?? undefined;
        message.mlaMatch = object.mlaMatch ?? undefined;
        message.fraudAlerts = (object.fraudAlerts !== undefined && object.fraudAlerts !== null)
            ? fraud_alert_1.FraudAlertTypes.fromPartial(object.fraudAlerts)
            : undefined;
        return message;
    },
};
function createBaseGetApplicationRequest() {
    return { applicationId: '' };
}
exports.GetApplicationRequest = {
    fromJSON(object) {
        const message = {
            applicationId: isSet(object.applicationId) ? globalThis.String(object.applicationId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.applicationId !== '') {
            obj.applicationId = message.applicationId;
        }
        return obj;
    },
    create(base) {
        return exports.GetApplicationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetApplicationRequest();
        message.applicationId = object.applicationId ?? '';
        return message;
    },
};
function createBaseGetApplicationResponse() {
    return { application: application_1.Application.fromPartial({}) };
}
exports.GetApplicationResponse = {
    fromJSON(object) {
        const message = {
            application: isSet(object.application)
                ? application_1.Application.fromJSON(object.application)
                : application_1.Application.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.GetApplicationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetApplicationResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : application_1.Application.fromPartial({});
        return message;
    },
};
function createBaseSetApplicationStatusRequest() {
    return { applicationId: '', status: application_1.ApplicationStatus.INVALID_APPLICATION_STATUS };
}
exports.SetApplicationStatusRequest = {
    fromJSON(object) {
        const message = {
            applicationId: isSet(object.applicationId) ? globalThis.String(object.applicationId) : '',
            status: isSet(object.status)
                ? (0, application_1.applicationStatusFromJSON)(object.status)
                : application_1.ApplicationStatus.INVALID_APPLICATION_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.applicationId !== '') {
            obj.applicationId = message.applicationId;
        }
        if (message.status !== application_1.ApplicationStatus.INVALID_APPLICATION_STATUS) {
            obj.status = (0, application_1.applicationStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.SetApplicationStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetApplicationStatusRequest();
        message.applicationId = object.applicationId ?? '';
        message.status = object.status ?? application_1.ApplicationStatus.INVALID_APPLICATION_STATUS;
        return message;
    },
};
function createBaseSetApplicationStatusResponse() {
    return { application: undefined };
}
exports.SetApplicationStatusResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.application)) {
            message.application = application_1.Application.fromJSON(object.application);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.SetApplicationStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetApplicationStatusResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : undefined;
        return message;
    },
};
function createBaseSetApplicationProductsRequest() {
    return { applicationId: '', products: [] };
}
exports.SetApplicationProductsRequest = {
    fromJSON(object) {
        const message = {
            applicationId: isSet(object.applicationId) ? globalThis.String(object.applicationId) : '',
        };
        if (globalThis.Array.isArray(object?.products)) {
            message.products = object.products.map((e) => product_1.Product.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.applicationId !== '') {
            obj.applicationId = message.applicationId;
        }
        if (message.products?.length) {
            obj.products = message.products.map((e) => product_1.Product.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SetApplicationProductsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetApplicationProductsRequest();
        message.applicationId = object.applicationId ?? '';
        message.products = object.products?.map((e) => product_1.Product.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSetApplicationProductsResponse() {
    return { application: undefined };
}
exports.SetApplicationProductsResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.application)) {
            message.application = application_1.Application.fromJSON(object.application);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.application !== undefined) {
            obj.application = application_1.Application.toJSON(message.application);
        }
        return obj;
    },
    create(base) {
        return exports.SetApplicationProductsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetApplicationProductsResponse();
        message.application = (object.application !== undefined && object.application !== null)
            ? application_1.Application.fromPartial(object.application)
            : undefined;
        return message;
    },
};
function createBaseSetCreditAgencyDataRequest() {
    return {
        userId: '',
        creditScore: undefined,
        hasFreeze: undefined,
        reasonCodes: undefined,
        isDeceased: undefined,
        mlaMatch: undefined,
        fraudAlerts: undefined,
    };
}
exports.SetCreditAgencyDataRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.creditScore)) {
            message.creditScore = globalThis.Number(object.creditScore);
        }
        if (isSet(object.hasFreeze)) {
            message.hasFreeze = globalThis.Boolean(object.hasFreeze);
        }
        if (isSet(object.reasonCodes)) {
            message.reasonCodes = reason_codes_1.ReasonCodes.fromJSON(object.reasonCodes);
        }
        if (isSet(object.isDeceased)) {
            message.isDeceased = globalThis.Boolean(object.isDeceased);
        }
        if (isSet(object.mlaMatch)) {
            message.mlaMatch = globalThis.Boolean(object.mlaMatch);
        }
        if (isSet(object.fraudAlerts)) {
            message.fraudAlerts = fraud_alert_1.FraudAlertTypes.fromJSON(object.fraudAlerts);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.creditScore !== undefined) {
            obj.creditScore = Math.round(message.creditScore);
        }
        if (message.hasFreeze !== undefined) {
            obj.hasFreeze = message.hasFreeze;
        }
        if (message.reasonCodes !== undefined) {
            obj.reasonCodes = reason_codes_1.ReasonCodes.toJSON(message.reasonCodes);
        }
        if (message.isDeceased !== undefined) {
            obj.isDeceased = message.isDeceased;
        }
        if (message.mlaMatch !== undefined) {
            obj.mlaMatch = message.mlaMatch;
        }
        if (message.fraudAlerts !== undefined) {
            obj.fraudAlerts = fraud_alert_1.FraudAlertTypes.toJSON(message.fraudAlerts);
        }
        return obj;
    },
    create(base) {
        return exports.SetCreditAgencyDataRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetCreditAgencyDataRequest();
        message.userId = object.userId ?? '';
        message.creditScore = object.creditScore ?? undefined;
        message.hasFreeze = object.hasFreeze ?? undefined;
        message.reasonCodes = (object.reasonCodes !== undefined && object.reasonCodes !== null)
            ? reason_codes_1.ReasonCodes.fromPartial(object.reasonCodes)
            : undefined;
        message.isDeceased = object.isDeceased ?? undefined;
        message.mlaMatch = object.mlaMatch ?? undefined;
        message.fraudAlerts = (object.fraudAlerts !== undefined && object.fraudAlerts !== null)
            ? fraud_alert_1.FraudAlertTypes.fromPartial(object.fraudAlerts)
            : undefined;
        return message;
    },
};
function createBaseSetCreditAgencyDataResponse() {
    return {};
}
exports.SetCreditAgencyDataResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetCreditAgencyDataResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetCreditAgencyDataResponse();
        return message;
    },
};
function createBaseGetCreditAgencyDataRequest() {
    return { userId: '' };
}
exports.GetCreditAgencyDataRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditAgencyDataRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditAgencyDataRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseGetCreditAgencyDataResponse() {
    return { data: exports.MockCreditAgencyData.fromPartial({}) };
}
exports.GetCreditAgencyDataResponse = {
    fromJSON(object) {
        const message = {
            data: isSet(object.data)
                ? exports.MockCreditAgencyData.fromJSON(object.data)
                : exports.MockCreditAgencyData.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.data !== undefined) {
            obj.data = exports.MockCreditAgencyData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditAgencyDataResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditAgencyDataResponse();
        message.data = (object.data !== undefined && object.data !== null)
            ? exports.MockCreditAgencyData.fromPartial(object.data)
            : exports.MockCreditAgencyData.fromPartial({});
        return message;
    },
};
function createBaseGetCreditScoreReasonsRequest() {
    return {};
}
exports.GetCreditScoreReasonsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCreditScoreReasonsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCreditScoreReasonsRequest();
        return message;
    },
};
function createBaseGetCreditScoreReasonsResponse() {
    return { reasons: {} };
}
exports.GetCreditScoreReasonsResponse = {
    fromJSON(object) {
        const message = {
            reasons: isObject(object.reasons)
                ? Object.entries(object.reasons).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reasons) {
            const entries = Object.entries(message.reasons);
            if (entries.length > 0) {
                obj.reasons = {};
                entries.forEach(([k, v]) => {
                    obj.reasons[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditScoreReasonsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditScoreReasonsResponse();
        message.reasons = Object.entries(object.reasons ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseGetCreditScoreReasonsResponseReasonsEntry() {
    return { key: '', value: '' };
}
exports.GetCreditScoreReasonsResponseReasonsEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditScoreReasonsResponseReasonsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditScoreReasonsResponseReasonsEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseWithdrawApplicationRequest() {
    return { userId: '' };
}
exports.WithdrawApplicationRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.WithdrawApplicationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWithdrawApplicationRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseWithdrawApplicationResponse() {
    return {};
}
exports.WithdrawApplicationResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.WithdrawApplicationResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseWithdrawApplicationResponse();
        return message;
    },
};
function createBaseResetReapplyCooldownRequest() {
    return { userId: '' };
}
exports.ResetReapplyCooldownRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.ResetReapplyCooldownRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResetReapplyCooldownRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseResetReapplyCooldownResponse() {
    return {};
}
exports.ResetReapplyCooldownResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ResetReapplyCooldownResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseResetReapplyCooldownResponse();
        return message;
    },
};
function createBaseUpdateTestUserRequest() {
    return { userId: '', user: undefined };
}
exports.UpdateTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        if (isSet(object.user)) {
            message.user = exports.TestUserData.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.user !== undefined) {
            obj.user = exports.TestUserData.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTestUserRequest();
        message.userId = object.userId ?? '';
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TestUserData.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function createBaseGetTestUserRequest() {
    return { userId: '' };
}
exports.GetTestUserRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserRequest();
        message.userId = object.userId ?? '';
        return message;
    },
};
function createBaseGetTestUserResponse() {
    return { user: undefined };
}
exports.GetTestUserResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.user)) {
            message.user = exports.TestUserData.fromJSON(object.user);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = exports.TestUserData.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.GetTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTestUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TestUserData.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function createBaseUpdateTestUserResponse() {
    return {};
}
exports.UpdateTestUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTestUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTestUserResponse();
        return message;
    },
};
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=underwriting-testing-service.js.map